<template>
  <nav class="t-tab-navigation">
    <nuxt-link
      v-for="link of links"
      :key="link.text"
      :to="link.link"
      class="tab"
    >
      {{ link.text }}
    </nuxt-link>
  </nav>
</template>

<script>
export default {
  name: 'LegalPagesNavigation',

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          link: this.$i18n.t('global.privacyPolicyLink'),
          text: this.$i18n.t('global.privacyPolicy'),
        },
        {
          link: this.$i18n.t('global.cookiePolicyLink'),
          text: this.$i18n.t('global.cookiePolicy'),
        },
        {
          link: this.$i18n.t('global.termsAndConditionsLink'),
          text: this.$i18n.t('global.termsAndConditions'),
        },
      ],
    }
  },

  computed: {
    /**
     * @returns {*}
     */
    country() {
      return this.$store.getters['context/get']('country')
    },
  },

  /**
   * Currently, we only show Imprint for our German concepts.
   */
  created() {
    if (this.country === 'de') {
      this.links.push({
        link: this.$i18n.t('global.imprintLink'),
        text: this.$i18n.t('global.imprint'),
      })
    }
  },
}
</script>
